import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Share2 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { api } from '../lib/api';
import { HoloStickerCard } from '../components/HoloStickerCard';
import { useI18n } from '../lib/i18n';
import { ShareModal } from '../components/ShareModal';

export function Missing() {
  const { token } = useAuth();
  const { t } = useI18n();
  const [shareOpen, setShareOpen] = useState(false);
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: () => api.me(token!) });
  const { data } = useQuery({
    queryKey: ['missing'],
    queryFn: () => api.missing(token!),
  });
  const stickers = data?.stickers ?? [];

  return (
    <div className="space-y-5">
      <header className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-2xs uppercase tracking-widest text-haze">{t('missing.eyebrow')}</p>
          <h1 className="font-display font-extrabold text-3xl">
            {t('missing.title')} <span className="text-flame">{stickers.length}</span>
          </h1>
        </div>
        {me?.shareSlug && stickers.length > 0 && (
          <button
            onClick={() => setShareOpen(true)}
            aria-label="share missing"
            className="shrink-0 mt-1 h-11 w-11 grid place-items-center rounded-full bg-flame text-white shadow-glow-flame hover:scale-110 transition"
          >
            <Share2 size={18} strokeWidth={2.5} />
          </button>
        )}
      </header>

      {me?.shareSlug && (
        <ShareModal
          open={shareOpen}
          onClose={() => setShareOpen(false)}
          shareSlug={me.shareSlug}
          displayName={me.displayName}
          mode="missing"
        />
      )}

      <div className="grid grid-cols-4 gap-2 md:grid-cols-6 lg:grid-cols-8">
        {stickers.map((s: any) => (
          <HoloStickerCard
            key={s.id}
            number={s.number}
            code={s.code}
            rarity={s.rarity}
            state="missing"
            playerName={s.player_name}
            team={s.team}
            size="sm"
          />
        ))}
      </div>
    </div>
  );
}
